import groq from 'groq'

const imageDimensionsFragment = groq`
  width,
  height,
  aspectRatio
`

export const imageFragment = groq`
  asset,
  crop,
  hotspot,
  customRatio,
  alt,
  caption,
  fixedHeight,
  borderRadius,
  "id": asset->assetId,
  "type": asset->mimeType,
  "lqip": asset->metadata.lqip,
  "dimensions": asset->metadata.dimensions {
    ${imageDimensionsFragment}
  }
`
